import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './tabs-content.styl'

export default class TabsContent extends Component {
  static propTypes = {
    children: PropTypes.any,
    tabs: PropTypes.array.isRequired,
    onTabChange: PropTypes.func
  }

  state = {
    activeIndex: 0
  }

  handleTabClick = (activeIndex, cbParam) => {
    this.setState(
      {
        activeIndex
      },
      () => {
        if (this.props.onTabChange) {
          this.props.onTabChange(cbParam)
        }
      }
    )
  }

  render() {
    const { children, tabs } = this.props
    const { activeIndex } = this.state
    const content = children.filter((item, index) => activeIndex === index)

    return (
      <div className={styles.wrap}>
        <ul className={styles.tabs}>
          {tabs.map((item, index) => (
            <li
              key={item.id}
              onClick={() => this.handleTabClick(index, item.cbParam)}
              className={`${styles.tab} ${activeIndex === index ? styles.active : ''}`}
            >
              {item.intlKey
                ? <FormattedMessage
                    id={item.intlKey}
                    defaultMessage={item.label}
                />
                : item.label}
            </li>
          ))}
        </ul>
        {content}
      </div>
    )
  }
}
